import { ConfigurationItemUi } from '@isdd/metais-common/api/generated/cmdb-swagger'
import { CiLazySelect } from '@isdd/metais-common/components/ci-lazy-select/CiLazySelect'
import { InformationGridRow } from '@isdd/metais-common/components/info-grid-row/InformationGridRow'
import React, { useState } from 'react'
import { UseFormSetValue } from 'react-hook-form'
import { MultiValue, OptionProps } from 'react-select'
import { Option } from '@isdd/idsk-ui-kit/common/SelectCommon'
import { ApiReferenceRegisterItemSourceReference } from '@isdd/metais-common/api/generated/reference-registers-swagger'
import { CloseIcon } from '@isdd/metais-common/assets/images'
import { Button, TextBody, TransparentButtonWrapper } from '@isdd/idsk-ui-kit/index'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import styles from './refRegisterItemViewItems.module.scss'

import { RefRegisterItemItemsFieldNames } from '@/types/filters'

interface iRefRegisterItemViewItemLazySelects {
    isChangeMode: boolean
    tooltip?: string
    value: ApiReferenceRegisterItemSourceReference[] | undefined
    name: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setValue: UseFormSetValue<any>
    label: string
    formValue: ApiReferenceRegisterItemSourceReference[] | undefined
    modal?: boolean
}

const selectLazyLoadingCiOption = (props: OptionProps<ConfigurationItemUi>) => {
    const attributes = props.data.attributes
    return (
        <Option {...props}>
            <div>
                <span>{attributes?.Gen_Profil_nazov as string}</span>
            </div>
            <span>
                <small>
                    {(attributes?.EA_Profil_PO_ulica ?? '') +
                        ' ' +
                        (attributes?.EA_Profil_PO_cislo ?? '') +
                        ', ' +
                        (attributes?.EA_Profil_PO_psc ?? '') +
                        ' ' +
                        (attributes?.EA_Profil_PO_obec ?? '')}
                </small>
            </span>
        </Option>
    )
}

export const RefRegisterItemViewItemLazySelects = ({
    name,
    label,
    value,
    tooltip,
    isChangeMode,
    setValue,
    formValue,
    modal,
}: iRefRegisterItemViewItemLazySelects) => {
    const { t } = useTranslation()
    const [selectedISVSCi, setSelectedISVSCi] = useState<ConfigurationItemUi | MultiValue<ConfigurationItemUi> | undefined>()
    const [selectedPOCi, setSelectedPOCi] = useState<ConfigurationItemUi | MultiValue<ConfigurationItemUi> | undefined>()

    const removeElementFromFormValues = (row: ApiReferenceRegisterItemSourceReference) => {
        const filteredValues =
            formValue?.filter((val) => val?.sourceIsvsUuid !== row?.sourceIsvsUuid && val?.sourceRegistratorUuid !== row?.sourceRegistratorUuid) ?? []
        setValue(RefRegisterItemItemsFieldNames.sourceReferenceHolders, filteredValues)
    }

    const getSourceElementHolders = () => {
        return value?.map((holder) => {
            return (
                <div key={holder?.sourceIsvsMetaisCode}>
                    {holder?.sourceIsvsMetaisCode + ' ' + holder?.sourceIsvsName + ' (' + holder?.sourceRegistratorName + ')'}
                </div>
            )
        })
    }

    if (isChangeMode)
        return (
            <div className={classNames({ [styles.inputPadding]: !modal })}>
                <fieldset className={styles.fieldset}>
                    <legend className="govuk-label">{label}</legend>
                    <CiLazySelect
                        ciType={'ISVS'}
                        label={t('refRegisters.detail.items.sourceElement')}
                        selectedCi={selectedISVSCi}
                        setSelectedCi={setSelectedISVSCi}
                        metaAttributes={{ state: ['DRAFT', 'APPROVED_BY_OWNER', 'AWAITING_APPROVAL'] }}
                    />
                    <CiLazySelect
                        ciType={'PO'}
                        label={t('refRegisters.detail.items.selectedPOCi')}
                        selectedCi={selectedPOCi}
                        setSelectedCi={setSelectedPOCi}
                        metaAttributes={{ state: ['DRAFT'] }}
                        option={selectLazyLoadingCiOption}
                    />
                    <Button
                        label={t('refRegisters.detail.items.addNewItemToForm')}
                        disabled={!selectedISVSCi || !selectedPOCi}
                        onClick={() => {
                            setValue(RefRegisterItemItemsFieldNames.sourceReferenceHolders, [
                                ...(formValue ?? []),
                                {
                                    sourceIsvsMetaisCode: (selectedISVSCi as ConfigurationItemUi)?.attributes?.Gen_Profil_kod_metais,
                                    sourceIsvsName: (selectedISVSCi as ConfigurationItemUi)?.attributes?.Gen_Profil_nazov,
                                    sourceIsvsUuid: (selectedISVSCi as ConfigurationItemUi)?.uuid,
                                    sourceRegistratorName: (selectedISVSCi as ConfigurationItemUi)?.attributes?.Gen_Profil_nazov,
                                    sourceRegistratorUuid: (selectedISVSCi as ConfigurationItemUi)?.uuid,
                                },
                            ])
                            setSelectedISVSCi(undefined)
                            setSelectedPOCi(undefined)
                        }}
                    />
                    {formValue?.map((val) => (
                        <TextBody key={`${val.sourceIsvsUuid}_${val.sourceRegistratorUuid}`}>
                            <TransparentButtonWrapper
                                onClick={() => {
                                    removeElementFromFormValues(val)
                                }}
                                aria-label={t('close')}
                            >
                                <img src={CloseIcon} alt="" className={styles.closeButton} />
                            </TransparentButtonWrapper>
                            <span>{[val?.sourceIsvsMetaisCode, val?.sourceIsvsName, `(${val?.sourceRegistratorName})`]?.join(' ')}</span>
                        </TextBody>
                    ))}
                </fieldset>
            </div>
        )
    return <InformationGridRow key={name} label={label} value={getSourceElementHolders()} tooltip={tooltip} />
}
